var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10237_64977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0206 12.834C22.4809 12.834 22.854 13.2071 22.854 13.6673V22.4685L25.5775 19.7448C25.9029 19.4193 26.4305 19.4193 26.756 19.7447C27.0814 20.0701 27.0815 20.5978 26.756 20.9232L22.5897 25.0899C22.2643 25.4153 21.7366 25.4154 21.4112 25.0899L17.2442 20.9233C16.9187 20.5978 16.9187 20.0702 17.2441 19.7448C17.5696 19.4193 18.0972 19.4193 18.4226 19.7447L21.1873 22.5091V13.6673C21.1873 13.2071 21.5604 12.834 22.0206 12.834Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 22.4174C14.9603 22.4174 15.3334 22.7905 15.3334 23.2508V24.0841C15.3334 25.2862 15.3352 26.1039 15.4175 26.7162C15.4966 27.3046 15.6361 27.5771 15.8216 27.7626C16.007 27.9481 16.2796 28.0875 16.8679 28.1667C17.4803 28.249 18.298 28.2508 19.5001 28.2508H24.5001C25.7022 28.2508 26.5199 28.249 27.1322 28.1667C27.7206 28.0875 27.9931 27.9481 28.1786 27.7626C28.3641 27.5771 28.5035 27.3046 28.5827 26.7162C28.665 26.1039 28.6668 25.2862 28.6668 24.0841V23.2508C28.6668 22.7905 29.0398 22.4174 29.5001 22.4174C29.9603 22.4174 30.3334 22.7905 30.3334 23.2508V24.1429C30.3334 25.2713 30.3335 26.2018 30.2345 26.9383C30.1305 27.7115 29.9039 28.3944 29.3571 28.9411C28.8103 29.4879 28.1275 29.7145 27.3543 29.8185C26.6178 29.9175 25.6873 29.9175 24.5589 29.9174H19.4413C18.3128 29.9175 17.3823 29.9175 16.6459 29.8185C15.8727 29.7145 15.1898 29.4879 14.6431 28.9411C14.0963 28.3944 13.8697 27.7115 13.7657 26.9383C13.6667 26.2018 13.6667 25.2713 13.6667 24.1429L13.6668 23.2508C13.6668 22.7905 14.0398 22.4174 14.5001 22.4174Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10237_64977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDownload);
export default __webpack_public_path__ + "static/media/action-download.7dcfb8cd14d573d533a6c9a20543fcd8.svg";
export { ForwardRef as ReactComponent };